// extracted by mini-css-extract-plugin
module.exports = {"count-title-tab":"style_count-title-tab__28kLO"};